var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "850" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("remove_red_eye")]),
                  _vm._v(" Ver permiso\n\t\t\t\t")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Número:")]),
                              _vm._v("   " + _vm._s(_vm.form.id))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Funcionario:")]),
                              _vm._v("   " + _vm._s(_vm.form.nombres))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Tipo de papeleta:")]),
                              _vm._v(
                                _vm._s(
                                  _vm.form.esAutoridad
                                    ? "FORMULARIO DE ASISTENCIA AUTORIDADES"
                                    : "CONTROL DE ASISTENCIA MANUAL"
                                ) + " "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      _vm.permiso_detalles != null
                        ? _c("h3", [
                            _c("strong", [_vm._v("Detalles de papeleta")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.permiso_detalles,
                          "hide-actions": "",
                          headers: _vm.headers
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    _vm._s(props.item.fecha) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(props.item.ingreso_am) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.salida_am))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.ingreso_pm))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.salida_pm))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.estado_detalle))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      _vm.permiso_detalles != null
                        ? _c("h3", [
                            _c("strong", [_vm._v("Seguimiento de la papeleta")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.seguimiento_detalles,
                          "hide-actions": "",
                          headers: _vm.headers2
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.fecha_registro))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.estado))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.usuario))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n\t\t\t\t\t"
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d903fdfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d903fdfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/registro_manual_asistencia/dialogs/VerAsistencia.vue
// module id = null
// module chunks = 